import { getBasicListInitialState, getBasicSingleReducerSlice } from '@probatix/common/utils/service'

import { STATE_KEY } from '../orderService.constants'
import { Voucher } from '../orderService.model'

export const slice = getBasicSingleReducerSlice<Voucher>(getBasicListInitialState(), STATE_KEY)

export default slice.reducer
